_this$props3$value